import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';
import Home from './pages/Home';
import RecipePage from './pages/RecipePage';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import CookieBanner from './components/CookieBanner';
import ScrollToTop from './components/ScrollToTop';

function App() {
	return (
		<Router>
			<div className="App">
				<ScrollToTop />
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/rezept/:id" element={<RecipePage />} />
					<Route path="/impressum" element={<Impressum />} />
					<Route path="/datenschutz" element={<Datenschutz />} />
				</Routes>
				<CookieBanner />
			</div>
		</Router>
	);
}

export default App;
